import { styled } from "@material-ui/core";

export const PaddedFlexBox = styled("div")(
  ({
    theme,
    spacing,
    fullWidth,
    alignItems = "inherit",
    justifycontent = "flex-start",
  }) => ({
    ...(fullWidth && { width: "100%" }),
    justifyContent: justifycontent,
    alignItems: alignItems,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(spacing || 2),
    },
  })
);

export const PaddedFlexBoxColumn = styled("div")(
  ({ theme, spacing, alignItems }) => ({
    flexDirection: "column",
    display: "flex",
    ...(alignItems && { alignItems }),
    "& > *:not(:last-child)": {
      marginBottom: theme.spacing(spacing !== undefined ? spacing : 1),
    },
  })
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/ui/Flex.js